const STORAGE_KEY = 'gl_personal_area_user';

export function readPersonalAreaSession() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.id || !parsed?.phone) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function savePersonalAreaSession(user) {
  if (!user?.id) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
}

export function clearPersonalAreaSession() {
  window.localStorage.removeItem(STORAGE_KEY);
}
